import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import programs from "../../data/programs";
import PageBanner from "../../components/layout/PageBanner";
// import PlaceholderImage from "../../components/common/PlaceholderImage";
import "./Programs.css";

const FILTERS = ["All", "High", "Medium", "Custom"];

export default function Programs() {
  const [filter, setFilter] = useState("All");
  const visible = filter === "All" ? programs : programs.filter((p) => p.intensity === filter);

  return (
    <>
      <Helmet>
        <title>Programs | Firm Fit Factory Peelamedu, Coimbatore</title>
        <meta name="description" content="Explore strength training, functional training, weight management, personal training, cardio conditioning and muscle building programs at Firm Fit Factory." />
        <link rel="canonical" href="https://www.firmfitfactory.com/programs" />
      </Helmet>

      <PageBanner eyebrow="Training Programs" title="Programs" description="Six coached tracks, each built around a clear training outcome." />

      <section className="section programs-page">
        <div className="container">
          <div className="programs-page__filters" role="tablist" aria-label="Filter programs by intensity">
            {FILTERS.map((f) => (
              <button
                key={f}
                type="button"
                role="tab"
                aria-selected={filter === f}
                className={`programs-page__filter ${filter === f ? "programs-page__filter--active" : ""}`}
                onClick={() => setFilter(f)}
              >
                {f}
              </button>
            ))}
          </div>

          <div className="programs-page__list">
            {visible.map((program) => {
              const Icon = program.icon;
              return (
                <article className="programs-page__item" id={program.id} key={program.id}>
                  <div className="programs-page__item-media">
                    {/* <PlaceholderImage tone="1" alt={`${program.title} at Firm Fit Factory`} ratio="4/3" /> */}
                    <img src={program.img} alt="" />
                  </div>
                  <div className="programs-page__item-body">
                    <div className="programs-page__item-head">
                      <Icon aria-hidden="true" />
                      <span className="programs-page__intensity">{program.intensity} Intensity</span>
                    </div>
                    <h2>{program.title}</h2>
                    <p className="programs-page__overview">{program.overview}</p>

                    <div className="programs-page__details">
                      <div>
                        <h3>Focus Areas</h3>
                        <ul>
                          {program.focusAreas.map((f) => <li key={f}>{f}</li>)}
                        </ul>
                      </div>
                      <div>
                        <h3>Session Structure</h3>
                        <ul>
                          {program.sessionStructure.map((s) => (
                            <li key={s.phase}><strong>{s.phase}:</strong> {s.detail}</li>
                          ))}
                        </ul>
                      </div>
                      <div>
                        <h3>Benefits</h3>
                        <ul>
                          {program.benefits.map((b) => <li key={b}>{b}</li>)}
                        </ul>
                      </div>
                    </div>

                    <p className="programs-page__suitable"><strong>Suitable for:</strong> {program.suitableFor}</p>
                    <Link to="/contact" className="btn btn-primary">Enquire About This Program</Link>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
